import { captureHighResFrame } from './canvasCapture';

const DRAW_CANVAS_ID = 'mdv-draw-canvas';

function fillRadialBackdrop(ctx, w, h) {
  const g = ctx.createRadialGradient(w * 0.5, h * 0.45, 0, w * 0.5, h * 0.45, Math.max(w, h) * 0.72);
  g.addColorStop(0, '#5a5a5a');
  g.addColorStop(0.38, '#404040');
  g.addColorStop(0.72, '#212121');
  g.addColorStop(1, '#141414');
  ctx.fillStyle = g;
  ctx.fillRect(0, 0, w, h);
}

function compositeDrawOverlay(ctx, destW, destH) {
  const overlay = document.getElementById(DRAW_CANVAS_ID);
  if (!overlay || overlay.width < 1 || overlay.height < 1) return;
  ctx.imageSmoothingEnabled = true;
  ctx.imageSmoothingQuality = 'high';
  ctx.drawImage(overlay, 0, 0, destW, destH);
}

export function downloadSceneScreenshot(gl, { filename, camera, scene, scale } = {}) {
  const { canvas: captured, width: w, height: h } = captureHighResFrame(gl, scene, camera, { scale });

  const out = document.createElement('canvas');
  out.width = w;
  out.height = h;
  const ctx = out.getContext('2d');
  fillRadialBackdrop(ctx, w, h);
  ctx.drawImage(captured, 0, 0, w, h);
  compositeDrawOverlay(ctx, w, h);

  const stamp = new Date().toISOString().replace(/[:.]/g, '-').slice(0, 19);
  const name = filename || `minedynamics-${stamp}.png`;

  return new Promise((resolve, reject) => {
    out.toBlob((blob) => {
      if (!blob) {
        reject(new Error('Could not encode PNG'));
        return;
      }
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = name;
      a.click();
      window.setTimeout(() => URL.revokeObjectURL(url), 2000);
      resolve(name);
    }, 'image/png');
  });
}
